import { get } from "./get"
import { getRealHoursOfStudy } from "./get-real-time"
import getWeeklyObjectiveApproval from "./id"
import { update } from "./update"

export const weeklyObjectives = {
  get,
  getWeeklyObjectiveApproval,
  update,
  getRealHoursOfStudy,
}
